import { type JSONConfig, Transparency } from '@/engine/app/interfaces.ts';

export const bones: JSONConfig.ViewObject = {
  descriptor: 'bones',
  transparency: Transparency.Medium,
  isVisible: true,
  isContourVisible: false
};

export const filter: JSONConfig.ViewObject = {
  descriptor: 'filter',
  transparency: Transparency.Opaque,
  isVisible: true,
  isContourVisible: false
};

export const hardware: JSONConfig.ViewObject = {
  descriptor: 'hardware',
  transparency: Transparency.Opaque,
  isVisible: true,
  isContourVisible: false
};

export const catheter: JSONConfig.ViewObject = {
  descriptor: 'catheter',
  transparency: Transparency.Opaque,
  isVisible: false,
  isContourVisible: false,
  isClippable: false
};

export const valve: JSONConfig.ViewObject = {
  descriptor: 'valve',
  transparency: Transparency.Opaque,
  isVisible: false,
  isContourVisible: false,
  isClippable: false
};

export const veinsCenterline: JSONConfig.ViewObject = {
  descriptor: 'vessel.centerline',
  transparency: Transparency.Opaque,
  isVisible: false,
  isContourVisible: false
};

export const veins: JSONConfig.ViewObject = {
  descriptor: 'vessel',
  transparency: Transparency.Opaque,
  isVisible: false,
  isContourVisible: false
};

export const veinsColored: JSONConfig.ViewObject = {
  descriptor: 'vessel.colored',
  transparency: Transparency.Low,
  isVisible: true,
  isContourVisible: false
};

export const leftAtrium: JSONConfig.ViewObject = {
  descriptor: 'left_atrium',
  transparency: Transparency.Opaque,
  isVisible: false,
  isContourVisible: false
};

export const landingZoneSpline: JSONConfig.ViewObject = {
  descriptor: 'landing_zone_spline',
  transparency: Transparency.Opaque,
  isVisible: true,
  isContourVisible: false,
  isPickable: false,
  isClippable: false
};

export const eustachianRidgeSpline: JSONConfig.ViewObject = {
  descriptor: 'tp.eustachian_ridge_spline.pts',
  transparency: Transparency.Opaque,
  isVisible: false,
  isContourVisible: false,
  isPickable: false
};

export const leftVentricle: JSONConfig.ViewObject = {
  descriptor: 'left_ventricle',
  transparency: Transparency.Opaque,
  isVisible: false,
  isContourVisible: false
};

export const rightAtrium: JSONConfig.ViewObject = {
  descriptor: 'right_atrium',
  transparency: Transparency.Medium,
  isVisible: true,
  isContourVisible: false
};

export const rightVentricle: JSONConfig.ViewObject = {
  descriptor: 'right_ventricle',
  transparency: Transparency.Medium,
  isVisible: true,
  isContourVisible: false
};

export const rightHeart: JSONConfig.ViewObject = {
  descriptor: 'right_heart',
  transparency: Transparency.Medium,
  isVisible: false,
  isContourVisible: false
};

export const aorta: JSONConfig.ViewObject = {
  descriptor: 'aorta',
  transparency: Transparency.Opaque,
  isVisible: true,
  isContourVisible: false
};

export const pulmonaryArtery: JSONConfig.ViewObject = {
  descriptor: 'pulmonary_artery',
  transparency: Transparency.Opaque,
  isVisible: true,
  isContourVisible: false
};

export const additionalDevice: JSONConfig.ViewObject = {
  descriptor: 'additional_device',
  transparency: Transparency.Opaque,
  isVisible: true,
  isContourVisible: false
};

export const additionalStructure: JSONConfig.ViewObject = {
  descriptor: 'additional_structure',
  transparency: Transparency.Opaque,
  isVisible: true,
  isContourVisible: false
};

export const calcification: JSONConfig.ViewObject = {
  descriptor: 'calcification',
  transparency: Transparency.Opaque,
  isVisible: true,
  isContourVisible: false
};

export const veinsCalcification: JSONConfig.ViewObject = {
  descriptor: 'vessel_calcification',
  transparency: Transparency.Opaque,
  isVisible: true,
  isContourVisible: false
};

export const femoralVeinsCustomPlane: JSONConfig.ViewObject = {
  descriptor: 'tp.pl_femoral_vessel_custom',
  transparency: Transparency.Opaque,
  isVisible: true,
  isContourVisible: false,
  isPickable: false,
  isTunable: false
};

export const femoralVeinsLeftPoint: JSONConfig.ViewObject = {
  descriptor: 'tp.pt_left_femoral_vessel',
  transparency: Transparency.Opaque,
  isVisible: true,
  isContourVisible: false,
  isPickable: false,
  isTunable: false
};

export const centerlineReferencePoint: JSONConfig.ViewObject = {
  descriptor: 'tp.pt_centerline_reference',
  transparency: Transparency.Opaque,
  isVisible: true,
  isContourVisible: false,
  isPickable: false,
  isTunable: false
};

export const femoralVeinsRightPoint: JSONConfig.ViewObject = {
  descriptor: 'tp.pt_right_femoral_vessel',
  transparency: Transparency.Opaque,
  isVisible: true,
  isContourVisible: false,
  isPickable: false,
  isTunable: false
};

export const arteriesKidneys: JSONConfig.ViewObject = {
  descriptor: 'arteries_kidneys',
  transparency: Transparency.Medium,
  isVisible: true,
  isContourVisible: false
};

export const basalRvAPoint: JSONConfig.ViewObject = {
  descriptor: 'tp.pt_basal_rv_a',
  transparency: Transparency.Opaque,
  isVisible: false,
  isContourVisible: false,
  isPickable: false,
  isTunable: false
};

export const basalRvPPoint: JSONConfig.ViewObject = {
  descriptor: 'tp.pt_basal_rv_p',
  transparency: Transparency.Opaque,
  isVisible: false,
  isContourVisible: false,
  isPickable: false,
  isTunable: false
};

export const basalRvSPoint: JSONConfig.ViewObject = {
  descriptor: 'tp.pt_basal_rv_s',
  transparency: Transparency.Opaque,
  isVisible: false,
  isContourVisible: false,
  isPickable: false,
  isTunable: false
};

export const basalRvLPoint: JSONConfig.ViewObject = {
  descriptor: 'tp.pt_basal_rv_l',
  transparency: Transparency.Opaque,
  isVisible: false,
  isContourVisible: false,
  isPickable: false,
  isTunable: false
};

export const basalRvTvAPoint: JSONConfig.ViewObject = {
  descriptor: 'tp.pt_basal_rv_tv_a',
  transparency: Transparency.Opaque,
  isVisible: false,
  isContourVisible: false,
  isPickable: false,
  isTunable: false
};

export const basalRvTvPPoint: JSONConfig.ViewObject = {
  descriptor: 'tp.pt_basal_rv_tv_p',
  transparency: Transparency.Opaque,
  isVisible: false,
  isContourVisible: false,
  isPickable: false,
  isTunable: false
};

export const basalRvTvSPoint: JSONConfig.ViewObject = {
  descriptor: 'tp.pt_basal_rv_tv_s',
  transparency: Transparency.Opaque,
  isVisible: false,
  isContourVisible: false,
  isPickable: false,
  isTunable: false
};

export const basalRvTvLPoint: JSONConfig.ViewObject = {
  descriptor: 'tp.pt_basal_rv_tv_l',
  transparency: Transparency.Opaque,
  isVisible: false,
  isContourVisible: false,
  isPickable: false,
  isTunable: false
};

export const raHeightPoint: JSONConfig.ViewObject = {
  descriptor: 'tp.pt_ra_height',
  transparency: Transparency.Opaque,
  isVisible: false,
  isContourVisible: false,
  isPickable: false,
  isTunable: false
};

export const rvDepthCoaxialPoint: JSONConfig.ViewObject = {
  descriptor: 'tp.pt_rv_depth',
  transparency: Transparency.Opaque,
  isVisible: false,
  isContourVisible: false,
  isPickable: false,
  isTunable: false
};

export const rvDepthApexPoint: JSONConfig.ViewObject = {
  descriptor: 'tp.pt_rv_depth_apex',
  transparency: Transparency.Opaque,
  isVisible: false,
  isContourVisible: false,
  isPickable: false,
  isTunable: false
};
